import * as Yup from "yup";

export const VehicleTypeSchema = Yup.object({

    type: Yup.string().required("Enter Vehicle Type Name"),
    status: Yup.string().required("Select Status"),
});